import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatTabGroup } from '@angular/material/tabs';
import { ToastService } from 'angular-toastify';
import { NgxSpinnerService } from 'ngx-spinner';

import { JIRA_BOARD_PROJECT_Name, OCI_Envirnoment } from 'src/app/constant/constant';
import { RepositoryService } from 'src/app/service/repository.service';
@Component({
  selector: 'app-compartmentcreate',
  templateUrl: './compartmentcreate.component.html',
  styleUrls: ['./compartmentcreate.component.css']
})
export class CompartmentcreateComponent implements OnInit {

  cloudForm: FormGroup;
  appRepoApps: any = [];
  filteredappRepoApps: any = [];
  projectName: string = JIRA_BOARD_PROJECT_Name.OCI;
  summary: string;
  @Input() tabGroup!: MatTabGroup;
  envirnoments: Array<any> = OCI_Envirnoment;
  filteredEnvirnoments: any = [...this.envirnoments];
  constructor(private fb: FormBuilder, private rs: RepositoryService, private _toastService: ToastService, private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    this.cloudForm = this.fb.group({
      appid: ['', [Validators.required]],
      budget: ['', [Validators.required, Validators.pattern(/^\$?\d+(?:,\d{3})*(?:\.\d+)?$/)]],
      environment: ['', [Validators.required]],
      description: ['', [Validators.required]]
    })
    this.getAppsFromAppRepo();
  }

  getAppsFromAppRepo(): void {
    this.spinner.show();

    this.rs.getAppsFromAppRepo("All").subscribe({
      next: (res) => {
        this.appRepoApps = res["Items"].map(item => ({
          ...item,
          result: `${item.appname} ${item.appid}`
        }));
        this.filteredappRepoApps = [...this.appRepoApps];
        this.spinner.hide();
      },
      error: (error) => {
        this.spinner.hide();
        this._toastService.error(error?.message || "Failed to load applications.");
      }
    });
  }


  handleFilteredReturn(filteredData: any[]): void {
    this.filteredappRepoApps = filteredData
  }
  handleFilteredEnvReturn(filteredData: any[]): void {
    this.filteredEnvirnoments = filteredData
  }

  resetform(): void {
    this.cloudForm.reset();
  }

  onSubmit(): void {
    this.spinner.show();
    this.summary = `Create a new cloud compartment on this appid:- ${this.cloudForm.get('appid')?.value} Requested by ${sessionStorage.getItem("email")}`;

    this.rs.createCloudServiceRequest(this.projectName, this.summary, this.cloudForm.value, sessionStorage.getItem("wwid")
    ).subscribe({
      next: (res) => {
        this._toastService.success(res['message']);
        this.resetform();
        if (this.tabGroup) { this.tabGroup.selectedIndex = 1 };
        this.spinner.hide();

      },
      error: (error) => {
        this._toastService.error(error?.message || "An unexpected error occurred.");
        this.spinner.hide();

      }
    });
  }


}
